/**
 * @generated SignedSource<<be6a3d1be2a9f51114a97506986bbce2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalSettingsViewQuery$variables = {
  containerId: string;
  id: string;
  isSuccessMeasuresEnabled: boolean;
  tql: string;
  workspaceUuid: string;
};
export type GoalSettingsViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalSettings">;
};
export type GoalSettingsViewQuery = {
  response: GoalSettingsViewQuery$data;
  variables: GoalSettingsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSuccessMeasuresEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v5 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v6 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v11 = {
  "kind": "ScalarField",
  "name": "value"
},
v12 = {
  "kind": "ScalarField",
  "name": "__id"
},
v13 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "includeDisabled",
    "value": true
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "kind"
},
v15 = [
  (v11/*: any*/)
],
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "LocalizationField"
},
v17 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v15/*: any*/),
      "type": "GoalTypeCustomName"
    },
    (v16/*: any*/)
  ]
},
v18 = {
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v15/*: any*/),
      "type": "GoalTypeCustomDescription"
    },
    (v16/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "state"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalSettingsViewQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "isSuccessMeasuresEnabled",
            "variableName": "isSuccessMeasuresEnabled"
          },
          {
            "kind": "Variable",
            "name": "tql",
            "variableName": "tql"
          },
          {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "id"
          }
        ],
        "kind": "FragmentSpread",
        "name": "GoalSettings"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalSettingsViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "tql"
          },
          (v6/*: any*/)
        ],
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              }
                            ],
                            "type": "CustomFieldDefinitionNode",
                            "abstractKey": "__isCustomFieldDefinitionNode"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/)
                            ],
                            "type": "UserCustomFieldDefinition"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "concreteType": "CustomFieldTextAllowedValueConnection",
                                "kind": "LinkedField",
                                "name": "allowedValues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v11/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "TextSelectCustomFieldDefinition"
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "type": "CustomFieldDefinition",
                        "abstractKey": "__isCustomFieldDefinition"
                      }
                    ],
                    "type": "CustomFieldDefinitionNode",
                    "abstractKey": "__isCustomFieldDefinitionNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": "connectionId",
                "kind": "ScalarField",
                "name": "__id"
              },
              (v12/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "SupportedCustomFields",
        "kind": "LinkedField",
        "name": "supportedCustomFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldTypeConfig",
            "kind": "LinkedField",
            "name": "typesConfig",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canSetAllowedValues"
              }
            ]
          }
        ]
      },
      {
        "alias": "totalCustomFieldDefinitions",
        "args": [
          {
            "kind": "Literal",
            "name": "q",
            "value": ""
          },
          (v6/*: any*/)
        ],
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "count"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "goalScoringMode"
          },
          (v8/*: any*/)
        ]
      },
      {
        "concreteType": "Townsquare",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "concreteType": "GoalTypeConnection",
            "kind": "LinkedField",
            "name": "goalTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ClientExtension",
                "selections": [
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isSuccessMeasuresEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "Townsquare",
            "kind": "LinkedField",
            "name": "townsquare",
            "plural": false,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "GoalTypeConnection",
                "kind": "LinkedField",
                "name": "goalTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "ari"
                          },
                          (v19/*: any*/),
                          {
                            "concreteType": "GoalType",
                            "kind": "LinkedField",
                            "name": "successMeasure",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v19/*: any*/),
                              (v14/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ec9b4b5c432d15377050917a471f8fca",
    "id": null,
    "metadata": {},
    "name": "GoalSettingsViewQuery",
    "operationKind": "query",
    "text": "query GoalSettingsViewQuery(\n  $id: ID!\n  $workspaceUuid: UUID!\n  $tql: String!\n  $isSuccessMeasuresEnabled: Boolean!\n  $containerId: String!\n) {\n  ...GoalSettings_4sTEAo\n}\n\nfragment CreateCustomFieldForm on SupportedCustomFields {\n  ...CustomFieldForm\n}\n\nfragment CustomFieldBaseRow on CustomFieldDefinition {\n  __isCustomFieldDefinition: __typename\n  __typename\n  ... on CustomFieldDefinitionNode {\n    __isCustomFieldDefinitionNode: __typename\n    id\n    name\n    type\n    description\n  }\n  ... on UserCustomFieldDefinition {\n    canSetMultipleValues\n  }\n  ... on TextSelectCustomFieldDefinition {\n    canSetMultipleValues\n    allowedValues {\n      edges {\n        node {\n          id\n          value\n        }\n      }\n    }\n  }\n}\n\nfragment CustomFieldDefinitionRow on CustomFieldDefinition {\n  __isCustomFieldDefinition: __typename\n  ... on CustomFieldDefinitionNode {\n    __isCustomFieldDefinitionNode: __typename\n    id\n  }\n  ...CustomFieldBaseRow\n  ... on Node {\n    __isNode: __typename\n    id\n  }\n}\n\nfragment CustomFieldForm on SupportedCustomFields {\n  typesConfig {\n    type\n    canSetMultipleValues\n    canSetAllowedValues\n  }\n}\n\nfragment CustomFieldList on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on CustomFieldDefinitionNode {\n        __isCustomFieldDefinitionNode: __typename\n        id\n        ...CustomFieldDefinitionRow\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment EditCustomFieldForm on SupportedCustomFields {\n  ...CustomFieldForm\n}\n\nfragment GoalScoringModeSetting on Workspace {\n  goalScoringMode\n}\n\nfragment GoalSettings_4sTEAo on Query {\n  ...TabPanelBody_Z4eZt\n  totalCustomFieldDefinitions: customFieldDefinitionTql(q: \"\", workspaceUuid: $workspaceUuid) {\n    count\n  }\n  workspace(id: $id) {\n    ...GoalScoringModeSetting\n    id\n  }\n  ...GoalTypeSettings_1GKbF9 @include(if: $isSuccessMeasuresEnabled)\n}\n\nfragment GoalTypeActions on GoalType {\n  ari\n  state\n}\n\nfragment GoalTypeRow on GoalType {\n  ...goalTypeName\n  ...goalTypeDescription\n  ...GoalTypeActions\n  id\n  successMeasure {\n    id\n    state\n    ...GoalTypeRowChild\n  }\n  kind\n}\n\nfragment GoalTypeRowChild on GoalType {\n  kind\n  ...goalTypeName\n  ...goalTypeDescription\n}\n\nfragment GoalTypeSettings_1GKbF9 on Query {\n  ...GoalTypesPanel_1GKbF9\n}\n\nfragment GoalTypesPanel_1GKbF9 on Query {\n  townsquare {\n    goalTypes(containerId: $containerId, includeDisabled: true, first: 100) {\n      edges {\n        node {\n          id\n          kind\n          ...GoalTypeRow\n        }\n      }\n    }\n  }\n}\n\nfragment TabPanelBody_Z4eZt on Query {\n  customFieldDefinitionTql(q: $tql, workspaceUuid: $workspaceUuid) {\n    edges {\n      __typename\n    }\n    ...CustomFieldList\n  }\n  supportedCustomFields {\n    ...CreateCustomFieldForm\n    ...EditCustomFieldForm\n  }\n}\n\nfragment goalTypeDescription on GoalType {\n  description {\n    __typename\n    ... on GoalTypeCustomDescription {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment goalTypeName on GoalType {\n  name {\n    __typename\n    ... on GoalTypeCustomName {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87f7bbf43b125be65aeb6d8ae8bc0b1e";

export default node;
